var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/MemberProfileEdit/MemberProfileEditSkills.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/MemberProfileEdit/MemberProfileEditSkills.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["data", "dictionaries"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});frame.set("dictionaries", Object.prototype.hasOwnProperty.call(kwargs, "dictionaries") ? kwargs["dictionaries"] : {});var t_5 = "";t_5 += "\n    <div class=\"MemberProfileEditSkills\">\n        <div class=\"MemberProfileEditSkills-body MemberProfileEdit-scrollbox\">\n            <form class=\"MemberProfileEditSkills-bodyForm\" enctype=\"multipart/form-data\" method=\"post\">\n\n                <div class=\"MemberProfileEditSkills-bodyForm-outer\">\n                    <div class=\"MemberProfileEditSkills-bodyForm-scrollBlock\">\n                        <div class=\"MemberProfileEditSkills-bodyForm-inner\">\n                            ";
frame = frame.push();
var t_8 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "dictionaries")),"skills");
if(t_8) {t_8 = runtime.fromIterator(t_8);
var t_7 = t_8.length;
for(var t_6=0; t_6 < t_8.length; t_6++) {
var t_9 = t_8[t_6];
frame.set("cat", t_9);
frame.set("loop.index", t_6 + 1);
frame.set("loop.index0", t_6);
frame.set("loop.revindex", t_7 - t_6);
frame.set("loop.revindex0", t_7 - t_6 - 1);
frame.set("loop.first", t_6 === 0);
frame.set("loop.last", t_6 === t_7 - 1);
frame.set("loop.length", t_7);
t_5 += "\n                                <div class=\"MemberProfileEditSkills-bodyForm-category\">\n                                    <span class=\"MemberProfileEditSkills-bodyForm-categoryName\">";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),0), env.opts.autoescape);
t_5 += ":</span>\n                                    <div class=\"MemberProfileEditSkills-bodyForm-categoryInner\">\n                                        ";
frame = frame.push();
var t_12 = runtime.memberLookup((t_9),1);
if(t_12) {t_12 = runtime.fromIterator(t_12);
var t_11 = t_12.length;
for(var t_10=0; t_10 < t_12.length; t_10++) {
var t_13 = t_12[t_10];
frame.set("item", t_13);
frame.set("loop.index", t_10 + 1);
frame.set("loop.index0", t_10);
frame.set("loop.revindex", t_11 - t_10);
frame.set("loop.revindex0", t_11 - t_10 - 1);
frame.set("loop.first", t_10 === 0);
frame.set("loop.last", t_10 === t_11 - 1);
frame.set("loop.length", t_11);
t_5 += "\n                                            <input type=\"checkbox\" id=\"skills-";
t_5 += runtime.suppressValue(runtime.memberLookup((t_13),0), env.opts.autoescape);
t_5 += "\" value=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((t_13),0), env.opts.autoescape);
t_5 += "\" class=\"MemberProfileEditSkills-bodyForm-input\"";
frame = frame.push();
var t_16 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"skills");
if(t_16) {t_16 = runtime.fromIterator(t_16);
var t_15 = t_16.length;
for(var t_14=0; t_14 < t_16.length; t_14++) {
var t_17 = t_16[t_14];
frame.set("itemSelected", t_17);
frame.set("loop.index", t_14 + 1);
frame.set("loop.index0", t_14);
frame.set("loop.revindex", t_15 - t_14);
frame.set("loop.revindex0", t_15 - t_14 - 1);
frame.set("loop.first", t_14 === 0);
frame.set("loop.last", t_14 === t_15 - 1);
frame.set("loop.length", t_15);
if(t_17 == runtime.memberLookup((t_13),0)) {
t_5 += "\n                                                            checked\n                                                        ";
;
}
;
}
}
frame = frame.pop();
t_5 += ">\n                                            <label class=\"MemberProfileEditSkills-bodyForm-categoryItem\"\n                                                   for=\"skills-";
t_5 += runtime.suppressValue(runtime.memberLookup((t_13),0), env.opts.autoescape);
t_5 += "\"><span>";
t_5 += runtime.suppressValue(runtime.memberLookup((t_13),1), env.opts.autoescape);
t_5 += "</span></label>\n                                        ";
;
}
}
frame = frame.pop();
t_5 += "\n                                    </div>\n                                </div>\n                            ";
;
}
}
frame = frame.pop();
t_5 += "\n                        </div>\n                    </div>\n                </div>\n\n            </form>\n        </div>\n        <div class=\"MemberProfileEditSkills-buttons\">\n            <div class=\"MemberProfileEditSkills-buttons-button MemberProfileEditSkills-buttons-button--cancel\">\n                cancel\n            </div>\n            <div class=\"MemberProfileEditSkills-buttons-button MemberProfileEditSkills-buttons-button--save\">\n                save\n            </div>\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("MemberProfileEditSkills");
context.setVariable("MemberProfileEditSkills", macro_t_4);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/MemberProfileEdit/MemberProfileEditSkills.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfileEdit/MemberProfileEditSkills.jinja
// module id = 120
// module chunks = 0